// extracted by mini-css-extract-plugin
module.exports = {"list":"errorsList_list__PctNs","button":"errorsList_button__xzbTE","errorLabel":"errorsList_errorLabel__3WfTF"};